// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReportsCashiers_title__IJhCG {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 4px;
}

.ReportsCashiers_subtitle__VyHMq {
  color: #666;
  margin-bottom: 20px;
}

.ReportsCashiers_filters__enP2m {
   display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 0.2fr));
  gap: 16px;
  margin-bottom: 20px;
}

.ReportsCashiers_dateInput__X-OQu {
  display: flex;
  flex-direction: column;
}

.ReportsCashiers_dateInput__X-OQu label {
  font-size: 14px;
  color: #444;
  margin-bottom: 4px;
}

.ReportsCashiers_dateInput__X-OQu input {
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
}

.ReportsCashiers_table__KeDtM {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  background-color: white;
}

.ReportsCashiers_table__KeDtM th {
  background-color: #f5f5f5;
  text-align: left;
  padding: 10px;
  font-weight: 600;
  border-bottom: 1px solid #ddd;
}

.ReportsCashiers_table__KeDtM td {
  padding: 10px;
  border-bottom: 1px solid #eee;
}

.ReportsCashiers_table__KeDtM tr:hover {
  background-color: #fafafa;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ReportsPages/ReportsCashiers.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;GACG,aAAa;EACd,6DAA6D;EAC7D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".title {\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.subtitle {\n  color: #666;\n  margin-bottom: 20px;\n}\n\n.filters {\n   display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 0.2fr));\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.dateInput {\n  display: flex;\n  flex-direction: column;\n}\n\n.dateInput label {\n  font-size: 14px;\n  color: #444;\n  margin-bottom: 4px;\n}\n\n.dateInput input {\n  padding: 6px 10px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  font-size: 14px;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n  background-color: white;\n}\n\n.table th {\n  background-color: #f5f5f5;\n  text-align: left;\n  padding: 10px;\n  font-weight: 600;\n  border-bottom: 1px solid #ddd;\n}\n\n.table td {\n  padding: 10px;\n  border-bottom: 1px solid #eee;\n}\n\n.table tr:hover {\n  background-color: #fafafa;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `ReportsCashiers_title__IJhCG`,
	"subtitle": `ReportsCashiers_subtitle__VyHMq`,
	"filters": `ReportsCashiers_filters__enP2m`,
	"dateInput": `ReportsCashiers_dateInput__X-OQu`,
	"table": `ReportsCashiers_table__KeDtM`
};
export default ___CSS_LOADER_EXPORT___;
